import { Dropdown, Menu, Form, Input, Modal, Button } from "antd";
import TextArea from "antd/lib/input/TextArea";
import { useState } from "react";
import Dragger from "antd/lib/upload/Dragger";
import { InboxOutlined } from "@ant-design/icons";

const AddPayout = (props) =>{
    const [form] = Form.useForm();
        const {
            addPayoutOpen,
            setAddPayoutOpen,
            dataSource2,
            setDataSource2
    
        } = props;
        const [payoutData, setPayoutData] = useState({});

        const handlePayoutCancel = () =>{
            setAddPayoutOpen(false)
        }

        const handleOk = () =>{
            setAddPayoutOpen(false)
        }

        const handleChange = (event) =>{
            setPayoutData({
                ...payoutData,
                [event.target.name]:event.target.value
            })
        }

        const handleFileChange = (info) =>{
            
            if(info.file.status === 'done'){
                setPayoutData({...payoutData, PayoutPath: info.file.originFileObj})
                
            }else if(info.file.status === 'error'){
                setPayoutData({...payoutData, PayoutPath: info.file.originFileObj})
                
            }
        }
    
        const handleSubmit = (event) => {
            
            event.preventDefault();
           
        }
    
        const uploadProps = {
            name:'file',
            multiple:false,
            accept:'.pdf',
            beforeUpload: (file) => {
                const isPDF = file.type === 'application/pdf';
                if(!isPDF){
                    console.log(`${file.name} is not a PDF`)
                }
                return isPDF;
            },
            onChange: handleFileChange
        }

        return(
            <Modal open={addPayoutOpen} width={500} maskStyle={{ backgroundColor: 'rgba(0, 0, 0, 0.2)' }} footer={[]} onOk={handleOk} onCancel={handlePayoutCancel}>
                <form style={{ margin: "10px" }} onSubmit={handleSubmit}>
            <Form.Item
                    label=""
                    placeholder="Enter Remark"
                    name="Remark"
                    onChange = {handleChange}
                    style={{ width: "auto", marginTop: "20px", }}
                >
                    <TextArea
                        style={{ margin: "0px" }}
                        name="RemarkPayout"
                        autoSize={{ minRows: 3, maxRows: 5 }}
                        onChange = {handleChange}
                        placeholder="Please add comment to submit"
                    // onChange={handleChange}
                    />
                </Form.Item>
                <Form.Item label="Attachment">
                <Dragger {...uploadProps}>
                    <p className="ant-upload-drag-icon">
                        <InboxOutlined />
                    </p>
                </Dragger>
                {/* <Upload>
                <Button  className="btn-upload" onClick={handleSubmit} onChange={handleChange} type="submit">UPLOAD</Button>
                </Upload> */}
                </Form.Item>
                <Button className="btn-upload-submit" onClick={handleSubmit} type="submit">SUBMIT</Button>
                </form>
                </Modal>
        )

}


export default AddPayout;